export default __webpack_public_path__ + "static/ministerstwo_cyfryzacji-5c3a4d9916e51eba94414a4b4ce093f2.webp";